module.exports = __webpack_public_path__ + "xi_text.7f2706d3.png";